/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationMemoDto } from '../../models/application-memo-dto';

export interface ApplicationAdminControllerUpdateMemoV1$Params {
  id: string;
      body: ApplicationMemoDto
}

export function applicationAdminControllerUpdateMemoV1(http: HttpClient, rootUrl: string, params: ApplicationAdminControllerUpdateMemoV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, applicationAdminControllerUpdateMemoV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

applicationAdminControllerUpdateMemoV1.PATH = '/api/v1/applications/admin/{id}/memo';
